export default __webpack_public_path__ + "static/media/Mobile-06.a7cb6079.jpg";